<template>
    <div>
        <div class="card mb-0 shadow" v-if="!editar_oficio">
            <div class="card-body">
                <div class="tab-content">
                    <div class="animate__animated animate__fadeIn">
                        <div class="row">
                            <div class="col-12">
                                <h4 class="font-weight-bold">Ofícios</h4>
                            </div>
                            <div class="col-md-12">
                                <div
                                    v-if="!nova_Oficio"
                                    class="animate__animated animate__fadeIn"
                                >
                                    <div class="row">
                                        <div class="col-12">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-4"
                                            >
                                                <div>
                                                    <button
                                                        class="btn btn-sm btn-primary"
                                                        @click="
                                                            nova_Oficio = true
                                                        "
                                                    >
                                                        <i
                                                            class="fas fa-plus-square"
                                                        />
                                                        {{ $t("Cadastrar") }}
                                                    </button>
                                                    <button
                                                        class="btn btn-sm btn-primary"
                                                        @click="
                                                            $bvModal.show(
                                                                'relacionar-model'
                                                            )
                                                        "
                                                    >
                                                        <i
                                                            class="mdi mdi-connection"
                                                        />
                                                        {{
                                                            $t(
                                                                "Relacionar com um existente"
                                                            )
                                                        }}
                                                    </button>
                                                </div>
                                                <div>
                                                    <div
                                                        class="input-group mb-3"
                                                    >
                                                        <b-input
                                                            :placeholder="
                                                                $t(
                                                                    'Type to search'
                                                                )
                                                            "
                                                            class="form-control search-input"
                                                            type="text"
                                                            v-model="search"
                                                            v-on:change="
                                                                getOficios
                                                            "
                                                            aria-describedby="input-search"
                                                        />
                                                        <div
                                                            class="input-group-append"
                                                            role="button"
                                                        >
                                                            <span
                                                                class="input-group-text"
                                                                id="input-search"
                                                                ><i
                                                                    class="fas fa-search search-icon"
                                                            /></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <load mode="table" v-if="loading" />
                                        <div class="col-12" v-else>
                                            <b-table
                                                :fields="[
                                                    {
                                                        key: 'numero',
                                                        label: $t('Detalhes'),
                                                    },
                                                    {
                                                        key: 'cadastrado',
                                                        label: $t('Data'),
                                                    },
                                                    {
                                                        key: 'status_nome',
                                                        label: $t('Status'),
                                                    },
                                                    {
                                                        key: 'actions',
                                                        label: '',
                                                        class: 'text-right',
                                                        thStyle: {
                                                            width: '95px',
                                                            minWidth: '95px',
                                                        },
                                                    },
                                                ]"
                                                :items="OficiosList"
                                                :responsive="true"
                                                striped
                                                hover
                                                show-empty
                                                small
                                                outlined
                                                stacked="md"
                                                table-class="mb-3"
                                            >
                                                <template
                                                    v-slot:cell(numero)="data"
                                                >
                                                    Número:
                                                    <strong>
                                                        {{ data.item.numero }}
                                                    </strong>
                                                    <br />
                                                    Destinatário:
                                                    <strong>
                                                        {{
                                                            data.item
                                                                .nome_completo_detinatario
                                                        }}
                                                    </strong>
                                                    <br />
                                                    Assunto:
                                                    <strong>
                                                        {{ data.item.assunto }}
                                                    </strong>
                                                    <br />
                                                    Técnico:
                                                    <strong>
                                                        {{ data.item.tecnico }}
                                                    </strong>
                                                    <br />
                                                    Técnico:
                                                    <strong>
                                                        {{
                                                            data.item.unidade
                                                                .nome
                                                        }}
                                                    </strong>
                                                </template>
                                                <template
                                                    v-slot:cell(cadastrado)="data"
                                                >
                                                    {{ data.item.cadastrado }}
                                                </template>
                                                <template
                                                    v-slot:cell(status_nome)="data"
                                                >
                                                    <span
                                                        class="small"
                                                        v-html="
                                                            data.item
                                                                .status_nome
                                                        "
                                                    ></span>
                                                </template>
                                                <template v-slot:cell()="data">
                                                    <button
                                                        @click="
                                                            oficioSelected =
                                                                data.item.id;
                                                            editar_oficio = true;
                                                        "
                                                        class="px-2 mb-0 btn btn-sm btn-success"
                                                    >
                                                        <i
                                                            class="mdi mdi-square-edit-outline"
                                                        />
                                                    </button>
                                                </template>
                                                <template v-slot:empty="scope">
                                                    <div
                                                        class="text-center my-5"
                                                    >
                                                        <img
                                                            :alt="
                                                                $t('No results')
                                                            "
                                                            class="mb-5"
                                                            src="/img/icons/robot.svg"
                                                            style="
                                                                max-height: 165px;
                                                            "
                                                        />
                                                        <h3 class="bold">
                                                            {{
                                                                $t(
                                                                    "No records found"
                                                                )
                                                            }}
                                                        </h3>
                                                    </div>
                                                </template>
                                            </b-table>

                                            <div class="row align-items-center">
                                                <div class="col-lg-6 col-md-12">
                                                    <div
                                                        class="form-group d-inline-flex mb-0"
                                                    >
                                                        <select
                                                            class="form-control"
                                                            style="width: 70px"
                                                            v-model="perPage"
                                                            v-on:change="
                                                                getOficios
                                                            "
                                                        >
                                                            <option value="5">
                                                                5
                                                            </option>
                                                            <option value="10">
                                                                10
                                                            </option>
                                                            <option value="25">
                                                                25
                                                            </option>
                                                            <option value="50">
                                                                50
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        class="d-inline-flex ml-2"
                                                    >
                                                        <b-pagination
                                                            :per-page="perPage"
                                                            :total-rows="
                                                                pagination.total
                                                            "
                                                            @change="changePage"
                                                            v-model="page"
                                                        />
                                                    </div>
                                                </div>
                                                <div
                                                    class="col-lg-6 col-md-12 mt-4 mt-lg-0"
                                                >
                                                    <div class="float-lg-right">
                                                        {{ $t("Showing page") }}
                                                        {{
                                                            pagination.currentPage
                                                        }}
                                                        {{ $t("of") }}
                                                        {{
                                                            pagination.totalPages
                                                        }}
                                                        {{ $t("pages in") }}
                                                        {{ pagination.total }}
                                                        {{ $t("records") }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <NovoOficio
                                    v-else
                                    @voltar="nova_Oficio = false"
                                    :familia="familia"
                                    :morph="{
                                        id: violacaodedireito.id,
                                        type: 'ViolenciaViolacaoDireito',
                                    }"
                                    @reload="
                                        getOficios();
                                        nova_Oficio = false;
                                    "
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <EditarOficio
            v-else
            :morph="true"
            :morph-oficio-id="oficioSelected"
            @voltar="editar_oficio = false"
        />
        <ModalRelacionar
            table="oficios"
            text="Ofício"
            :item-id="violacaodedireito.id"
            label="Digite ou selecione o Número/Ano"
            @reload="getOficios"
        />
    </div>
</template>
<script>
import NovoOficio from "../../../../../../Oficio/Resources/assets/js/Add";
import EditarOficio from "../../../../../../Oficio/Resources/assets/js/Edit";
import ListOficios from "./lista/ListOficios";
import ModalRelacionar from "../ModalRelacionar";

export default {
    props: ["violacaodedireito"],
    components: {
        NovoOficio,
        EditarOficio,
        ModalRelacionar,
        ListOficios,
    },
    name: "Oficios",
    metaInfo() {
        return {
            title: this.$i18n.t("Oficios"),
        };
    },
    data() {
        return {
            familia: {},
            oficioSelected: "",
            editar_oficio: false,
            nova_Oficio: false,
            TipoOficiosList: [],
            OficiosList: [],
            page: 1,
            search: "",
            perPage: 10,
            loading: true,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
        };
    },
    mounted() {
        if (typeof this.$route.query.item === "object") {
            this.familia = this.$route.query.item;
        } else {
            this.getFamilia();
        }
        this.getOficios();
    },
    methods: {
        getOficios() {
            this.loading = true;
            axios
                .get("api/dashboard/oficios", {
                    params: {
                        id: this.$route.query.familia_id,
                        morph_type: "ViolenciaViolacaoDireito",
                        morph_id: this.violacaodedireito.id,
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                    },
                })
                .then((response) => {
                    this.OficiosList = response.data.table.data;
                    this.pagination = response.data.table.pagination;

                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getOficios();
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getOficios();
            }
        },
        redirectOficio(id) {
            this.$router.push({
                path: `/dashboard/oficios/edit/${id}`,
                query: { familia_id: this.$route.query.familia_id },
            });
        },
        getFamilia() {
            axios
                .get("api/dashboard/familias/" + this.$route.query.familia_id)
                .then((response) => {
                    this.familia = response.data.data;
                    this.$route.query.familia_id = this.familia.id;
                    this.loading = false;
                })
                .catch(() => {
                    this.$router.push("/dashboard/familias");
                });
        },
    },
};
</script>
